import { type FetchAclPartnerSamlLoginParams } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useAtom } from 'jotai';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { partnerAPIDataAtom, partnerAPILoginDataAtom } from '../data-access/atoms';

export const useAPIFlowKeepParams = () => {
	const { replace, searchParams } = useRouter();
	const SAMLRequest = searchParams?.get('SAMLRequest') as FetchAclPartnerSamlLoginParams['SAMLRequest'];
	const RelayState = searchParams?.get('RelayState') as FetchAclPartnerSamlLoginParams['RelayState'];
	const Signature = searchParams?.get('Signature') as FetchAclPartnerSamlLoginParams['Signature'];
	const SigAlg = searchParams?.get('SigAlg') as FetchAclPartnerSamlLoginParams['sigAlg'];
	const originPartnerAPI = searchParams.get('origin_partner_api') as string;
	const organizationName = searchParams.get('organization_name') as string;
	const [partnerAPILoginDataAtomValue, setPartnerAPILoginDataAtom] = useAtom(partnerAPILoginDataAtom);
	const [partnerAPIDataAtomValue, sePartnerAPIDataAtom] = useAtom(partnerAPIDataAtom);
	const pathname = usePathname();

	if (!partnerAPIDataAtomValue && originPartnerAPI === 'true' && organizationName) {
		sePartnerAPIDataAtom({
			organization_name: organizationName,
			origin_partner_api: originPartnerAPI
		});
	}

	if (!partnerAPILoginDataAtomValue && SAMLRequest && RelayState && Signature && SigAlg) {
		setPartnerAPILoginDataAtom({
			RelayState,
			SAMLRequest,
			SigAlg,
			Signature
		});
	}

	useEffect(() => {
		if (searchParams?.size > 0) return;
		if (partnerAPIDataAtomValue || partnerAPILoginDataAtomValue) {
			replace(
				`${pathname}?${new URLSearchParams({ ...partnerAPIDataAtomValue, ...partnerAPILoginDataAtomValue } as Record<string, string>).toString()}`
			);
		}
	}, [replace, searchParams, pathname, partnerAPIDataAtomValue, partnerAPILoginDataAtomValue]);
};
